
// Components
import ICONS from '@/common-utils/enums/icons';
import Entity from '../entity/Entity';

/**
 * Maintenance Component
 *
 * This component is used to display a maintenance message to the user.
 *
 * @returns {JSX} Maintenance Component
 */
function Maintenance() {
    return (
        <div className='w-screen h-screen flex p-4' style={{ background: 'linear-gradient(to top, #00b4db, #0083b0)' }}>
            <div className='flex flex-col m-auto max-w-sm gap-2 text-white'>
                <Entity entity='Maintenance en cours' className='text-3xl font-bold self-center' icon={ICONS.MAINTENANCE} iconSize={30} />
                <div className='text-justify border-t border-white pt-2'>
                    Afin d{'\''}améliorer le service offert à nos utilisateurs,
                    nous menons actuellement une opération de maintenance sur le portail
                    de gestion monétique. <br /><br />
                    <b>Cette opération n{'\''}affecte pas les communications monétiques.</b><br /><br />
                    La maintenance devrait durer jusqu{'\''}à environ 10h30 (heure de Paris).<br /><br />
                    D{'\''}avance merci pour votre compréhension.<br /><br />
                    L{'\''}équipe produit
                </div>
            </div>
        </div>
    );
}

export default Maintenance;